document.addEventListener("DOMContentLoaded", function () {
	function waitForElm(selector) {
		return new Promise(resolve => {
			if (document.querySelector(selector)) {
				return resolve(document.querySelector(selector));
			}

			const observer = new MutationObserver(mutations => {
				if (document.querySelector(selector)) {
					resolve(document.querySelector(selector));
					observer.disconnect();
				}
			});

			observer.observe(document.body, {
				childList: true,
				subtree: true
			});
		});
	}

	submitReviewQSValue = false;
	var reviewWidget = document.getElementsByClassName("jdgm-rev-widg")[0];
	var productReviewRating = reviewWidget.getAttribute("data-average-rating");
	var ratingElement = document.getElementsByClassName("jdgm-rev-widg__summary")[0];
	ratingElement.setAttribute('data-before', Math.round(productReviewRating * 10) / 10);

	//watch reviews for changes
	var reviewsContainer = document.getElementsByClassName("jdgm-rev-widg__body")[0];
	var mutationObserver = new MutationObserver(function (mutations) {
		mutationObserver.disconnect();
		reShuffleReviewContent();
	});

	var reviewFormOpen = false;
	var reviewFormWrapper;
	var stickyAddToCart = document.getElementsByClassName("product-sticky-form")[0];
	var adminBar = document.getElementById("admin-bar-iframe");
	//watch review form for display change
	var reviewFormObserver = new MutationObserver(function (mutations) {
		if (getComputedStyle(reviewFormWrapper).display == "none" && reviewFormOpen == true) {
			//flag form as hidden
			reviewFormOpen = false;
			//show previously hidden elements
			if (stickyAddToCart) { stickyAddToCart.style.display = "block"; }
			if (adminBar) { adminBar.style.display = "block"; }

		} else if (getComputedStyle(reviewFormWrapper).display == "block" && reviewFormOpen == false) {
			//flag form as open
			reviewFormOpen = true;
			//hide distraction elements
			if (stickyAddToCart) { stickyAddToCart.style.display = "none"; }
			if (adminBar) { adminBar.style.display = "none"; }
		}
	});

	function startObservingReviewForm() {
		reviewFormWrapper = document.getElementsByClassName("jdgm-form-wrapper")[0];
		if (!reviewFormWrapper) {
			//wait and recheck
			setTimeout(startObservingReviewForm, 100);
			return;
		} else {
			reviewFormObserver.observe(reviewFormWrapper, {
				attributes: true,
				attributeFilter: ["style"]
			});
		}
	}
	startObservingReviewForm();

	actionsInitialized = false;

	function reShuffleReviewContent() {
		//shuffle content
		var allReviews = document.getElementsByClassName("jdgm-rev");
		for (var i = 0, review; review = allReviews[i]; i++) {
			if (review.getAttribute("editted") != "true") {
				//move buyer badge and author
				var buyerBadge = review.getElementsByClassName("jdgm-rev__buyer-badge-wrapper")[0];
				var authorWrapper = review.getElementsByClassName("jdgm-rev__author-wrapper")[0];
				var reviewContentContainer = review.getElementsByClassName("jdgm-rev__content")[0];
				var authorDataContainer = document.createElement("div");
				authorDataContainer.classList.add("jdgm-authorDataContainer");
				authorDataContainer.appendChild(buyerBadge);
				authorDataContainer.appendChild(authorWrapper);

				//move experience and drives a, adjust recommendation
				var customForm = null;
				var customFormAnswers = null;
				customForm = review.getElementsByClassName("jdgm-rev__custom-form")[0];
				customFormAnswers = customForm.getElementsByClassName("jdgm-rev__cf-ans");
				var customFormAnswerExperience = null;
				var customFormAnswerDrives = null;
				var customFormAnswerRecommendation = null;
				var howOldAnswer = null;
				var improvementAnswer = null;
				for (var j = 0, customFormAnswer; customFormAnswer = customFormAnswers[j]; j++) {
					var customFormAnswerTitle = null;
					customFormAnswerTitle = customFormAnswer.getElementsByClassName("jdgm-rev__cf-ans__title")[0];

					//handle imported reviews START
					var answerValue = "";
					var barsWrapper = document.createElement("div");
					var barsElement = document.createElement("a");
					barsWrapper.classList.add("jdgm-cf-bars-wrapper");
					barsElement.setAttribute("href", "#");
					barsElement.setAttribute("rel", "nofollow");
					barsElement.classList.add("jdgm-cf-bar");
					barsWrapper.appendChild(barsElement.cloneNode(true));
					barsWrapper.appendChild(barsElement.cloneNode(true));
					barsWrapper.appendChild(barsElement.cloneNode(true));
					barsWrapper.appendChild(barsElement.cloneNode(true));
					barsWrapper.appendChild(barsElement.cloneNode(true));
					if (customFormAnswerTitle.innerHTML == "Quality:" || customFormAnswerTitle.innerHTML == "Value:" || customFormAnswerTitle.innerHTML == "DIY Ease:") {
						//search for value element
						var customFormAnswerValueContainer = customFormAnswer.getElementsByClassName("jdgm-rev__cf-ans__value")[0];
						if (customFormAnswerValueContainer) {
							//check value
							answerValue = customFormAnswerValueContainer.innerHTML.charAt(0);
							//remove
							customFormAnswerValueContainer.remove();
							//replace
							var barsElementBars = barsWrapper.getElementsByClassName("jdgm-cf-bar");
							for (var m = 0, barsElementBar; barsElementBar = barsElementBars[m]; m++) {
								if (m + 1 <= answerValue) {
									barsElementBar.classList.add("jdgm--filled");
								}
							}
							customFormAnswer.appendChild(barsWrapper.cloneNode(true));
						}
					}
					if (customFormAnswerTitle.innerHTML == "How old are you?" || customFormAnswerTitle.innerHTML == "How old are you?:") {
						howOldAnswer = customFormAnswer;//remove outside of for loop
					}
					if (customFormAnswerTitle.innerHTML == "How could we improve this product? (optional)" || customFormAnswerTitle.innerHTML == "How could we improve this product? (optional):") {
						improvementAnswer = customFormAnswer;//remove outside of for loop
					}
					//handle imported reviews END

					if (customFormAnswerTitle.innerHTML == "Experience:") {
						customFormAnswerExperience = customFormAnswer;
					} else if (customFormAnswerTitle.innerHTML == "Drives:") {
						customFormAnswerDrives = customFormAnswer;
					} else if (customFormAnswerTitle.innerHTML == "Recommends to a friend?:" || customFormAnswerTitle.innerHTML == "Recommends to a friend?" || customFormAnswerTitle.innerHTML == "Would you recommend this product to a friend?" || customFormAnswerTitle.innerHTML == "Would you recommend this product to a friend?:") {
						customFormAnswerRecommendation = customFormAnswer;
					}
				}

				if (howOldAnswer) {
					howOldAnswer.remove();
				}
				if (improvementAnswer) {
					improvementAnswer.remove();
				}

				if (customFormAnswerRecommendation) {
					customFormAnswerRecommendation.classList.add("jdgm-customFormAnswerRecommendation");
					var recommendationCheckbox = document.createElement("div");
					recommendationCheckbox.innerHTML = '<svg focusable="false" width="20" height="20" class="icon icon--check" viewBox="0 0 32 32"><path d="M24.59 8L12.9885 20.6731L7.31806 15.1819L6 16.6956L12.3755 22.8792L13.0805 23.5556L13.7395 22.8309L26 9.43318L24.59 8Z" stroke="#000"></path></svg>';
					customFormAnswerRecommendation.prepend(recommendationCheckbox);

				}

				if (customFormAnswerExperience) { authorDataContainer.appendChild(customFormAnswerExperience); }
				if (customFormAnswerDrives) { authorDataContainer.appendChild(customFormAnswerDrives); }
				if (authorDataContainer) { reviewContentContainer.appendChild(authorDataContainer); }
				if (customFormAnswerRecommendation) { reviewContentContainer.appendChild(customFormAnswerRecommendation); }

				//mark as editted
				review.setAttribute("editted", "true");
			}
		}
		
		waitForElm('.jdgm-widget-actions-wrapper').then((elm) => {
			if(!actionsInitialized){
				actionsInitialized = true;
				//clean review form link
				reviewFormLink = document.getElementsByClassName("jdgm-write-rev-link")[0];
				reviewFormLink.addEventListener("click", function (e) {
					e.preventDefault();
					adjustReviewFormContent();
				});
				reviewFormLink.style.display = "inline-block";
			}
			
		});
		//connect observer
		mutationObserver.observe(reviewsContainer, {
			attributes: false,
			characterData: false,
			childList: true,
			subtree: true,
			attributeOldValue: false,
			characterDataOldValue: false
		});
	}

	reviewFormContainer = "";

	function adjustReviewFormContent() {
		//disable page scrolling
		document.body.style.overflow = "hidden";
		//scroll form back to top
		reviewFormContainer = document.getElementsByClassName("jdgm-form-wrapper")[0];
		reviewFormContainer.scrollTop = 0;
		reviewFormContainer.style.display = "flex";

		var reviewForm = document.getElementsByClassName("jdgm-form")[0];
		var customFormContainer = document.getElementsByClassName("jdgm-custom-forms")[0];
		var customFormQuestions = document.getElementsByClassName("jdgm-cf");
		if (customFormQuestions.length == 0) {
			//wait and recheck
			setTimeout(adjustReviewFormContent, 100);
			return;
		}
		for (var i = 0; i < customFormQuestions.length; i++) {
			var customFormQuestion = customFormQuestions[i];
			var questionLabel = customFormQuestion.getElementsByClassName("jdgm-cf__quest-label")[0].getElementsByTagName("b")[0].innerHTML;
			//check for bars
			var barsWrapper = customFormQuestion.getElementsByClassName("jdgm-cf-bars-wrapper");
			if (barsWrapper.length) {
				//bars found
				//add slider
				var questionSlider = document.createElement("input");
				questionSlider.setAttribute("type", "range");
				questionSlider.setAttribute("min", "1");
				questionSlider.setAttribute("max", "5");
				questionSlider.setAttribute("value", "5");
				questionSlider.classList.add('jdgm-questionSlider');
				questionSlider.classList.add('styled-slider');
				questionSlider.classList.add('slider-progress');
				//get input name to affect
				var inputNameToAffect = customFormQuestion.getElementsByClassName("jdgm-cf-input")[0].getAttribute("name");
				questionSlider.setAttribute("nametoaffect", inputNameToAffect);

				sliderCheckInputField(inputNameToAffect, "5/5");

				//hide default inputs
				var inputsToHide = customFormQuestion.getElementsByTagName("input");
				for (var m = 0, inputToHide; inputToHide = inputsToHide[m]; m++) {
					inputToHide.classList.add('jdgm-sliderQuestionsHideFields');
				}

				var labelsToHide = customFormQuestion.getElementsByClassName("jdgm-cf__option");
				for (var m = 0, labelToHide; labelToHide = labelsToHide[m]; m++) {
					labelToHide.classList.add('jdgm-sliderQuestionsHideFields');
				}

				questionSlider.oninput = function () {
					var outputValue = this.value + "/5";
					var inputNameSearch = this.getAttribute("nametoaffect");
					sliderCheckInputField(inputNameSearch, outputValue);
				}
				customFormQuestion.appendChild(questionSlider);
			}
		}

		//apply slider styling
		for (let e of document.querySelectorAll('input[type="range"].slider-progress')) {
			e.style.setProperty('--value', e.value);
			e.style.setProperty('--min', e.min == '' ? '0' : e.min);
			e.style.setProperty('--max', e.max == '' ? '100' : e.max);
			e.addEventListener('input', () => e.style.setProperty('--value', e.value));
		}

		reviewForm.onclick = function(e){
			e.stopPropagation();
		};

		document.getElementsByClassName("jdgm-write-rev-link")[0].innerHTML = "Write a review";
		document.getElementsByClassName("jdgm-write-rev-link")[0].classList.remove("close-form-btn");

		//add custom elements into the form
		customReviewSubmissionHeader = document.getElementById("review_submission_header");
		customReviewProductPhoto = document.getElementById("review_submission_product_photo");
		customReviewFormHeadline = document.getElementById("review_submission_product_form_headline");
		
		if(!reviewFormContainer.contains(customReviewProductPhoto)){
			reviewFormContainer.prepend(customReviewProductPhoto);
			customReviewProductPhoto.style.display = "block";
		}
		if(!reviewFormContainer.contains(customReviewSubmissionHeader)){
			reviewFormContainer.prepend(customReviewSubmissionHeader);
			customReviewSubmissionHeader.style.display = "flex";
			document.getElementsByClassName("custom-close-form-btn")[0].onclick = function(e){
				e.preventDefault();
				customCloseReviewForm();
			};
		}
		if(!reviewForm.contains(customReviewFormHeadline)){
			reviewForm.prepend(customReviewFormHeadline);
			customReviewFormHeadline.style.display = "block";
		}

		//move video section to start of custom form
		videoSectionHeadline = document.getElementsByClassName("jdgm-picture-fieldset-title")[0];
		videoSectionHeadline.textContent = "SHOW OFF YOUR PRIDE AND JOY (OPTIONAL)"
		videoSectionUploadButtons = document.getElementsByClassName("jdgm-picture-fieldset")[0];
		videoSectionYTform = document.getElementsByClassName("jdgm-form__yt-video-fieldset")[0];
		reviewForm.insertBefore(videoSectionHeadline, customFormContainer);
		reviewForm.insertBefore(videoSectionUploadButtons, customFormContainer);
		reviewForm.insertBefore(videoSectionYTform, customFormContainer);
		
	}

	function sliderCheckInputField(inputNameSearch, outputValue) {
		var inputFieldToAffect = document.querySelectorAll('.jdgm-form-wrapper [name="' + inputNameSearch + '"]' + '[value="' + outputValue + '"]');
		inputFieldToAffect[0].checked = true;
		document.activeElement.blur();
	}

	function customCloseReviewForm(){
		document.body.style.overflow = "auto";
		reviewFormContainer.style.display = "none";
		document.getElementsByClassName("jdgm-write-rev-link")[0].innerHTML = "Write a review";
		document.getElementsByClassName("jdgm-write-rev-link")[0].classList.remove("close-form-btn");
	}

	reShuffleReviewContent();

	/*open via URL if param present*/
	const qsparams = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});
	submitReviewQSValue = qsparams.submitReview;
	if(submitReviewQSValue){
		//scroll down to section
		var element_to_scroll_to = document.getElementById('judgeme_product_reviews');
		element_to_scroll_to.scrollIntoView();

		//clean param from qs
		// Get current URL
		const currentUrl = new URL(window.location.href); 
		// Update or remove a param
		currentUrl.searchParams.delete('submitReview');
		// Now update the current URL
		window.history.replaceState(null, '', currentUrl); 

		autoOpenInitialized = false;
		waitForElm('.jdgm-write-rev-link').then((elm) => {
			if(!autoOpenInitialized){
				autoOpenInitialized = true;
				autoOpenWrapperInitialized = false;
				waitForElm('.jdgm-form-wrapper').then((elm) => {
					if(!autoOpenWrapperInitialized){
						autoOpenWrapperInitialized = true;
						setTimeout(function() {
							document.getElementsByClassName("jdgm-write-rev-link")[0].dispatchEvent(new Event('click'));
						}, 500);
					}
				});
			}
		});
	}

})